import React from 'react';
import { ToastContainer } from 'react-toastify';
import PtpVlanIpBody from './PtpVlanIpBody';
import PtpVlanIpProvider from './provider/PtpVlanIpProvider';
import useCheckTwoDepartments from '../../../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';
import { admin, NOC } from '../../../../../../utils/config';
import { useUser } from '../../../../../../hooks/shared/user/useUser';
import NocNavBar from '../../../../../layouts/noc/NocNavBar';
import { VICE_PRESIDENT_FSE } from '../../../../../../utils/departments/helpers';

const PtpVlanIp = ({ history }) => {
  const { profile } = useUser();
  const { firstName } = profile;
  useCheckTwoDepartments(`${NOC}`, `${VICE_PRESIDENT_FSE}`, `${admin}`, history);
  return (
    <div className="s-layout">
      <PtpVlanIpProvider>
        <main className="s-layout__content col-lg-10 p-0">
          <NocNavBar currentPage="NOC Sheet - PTP Vlan IP" position={firstName} />
          <PtpVlanIpBody />
        </main>
        <ToastContainer />
      </PtpVlanIpProvider>
    </div>
  );
};

export default PtpVlanIp;
